import { useState, useEffect } from 'react';
import { decorationRepository } from '../../../domain/decorationsRepository';


export const useDecorations = (typeId, page) => {
    const [decorationsResult, setDecorationsResult] = useState([]);

    useEffect(() => {
        console.log(`trigger useDecorations typeId: ${typeId}`)
        console.log(`trigger useDecorations page: ${page}`)
        decorationRepository.getDecorations(typeId, page)
        .then((result) => {
            setDecorationsResult(result)
        })
        .catch((err) => {
            console.error("Failed to fetch decoration types:", err)
        });
    }, [typeId, page]);

    return decorationsResult;
};